<script setup lang="ts">
// Wadah toast, dipasang sekali di App.vue. Diberi aria-live agar pembaca layar
// ikut mengumumkan hasil aksi — tanpa itu pengguna yang tidak melihat layar
// tak pernah tahu penyimpanan berhasil.
import { useToastStore } from '@/stores/toast'
import AppIcon from '@/components/AppIcon.vue'

const toast = useToastStore()

const KELAS: Record<string, string> = {
  sukses: 'border-green-200 bg-green-50 text-green-900',
  galat: 'border-red-200 bg-red-50 text-red-900',
  info: 'border-sky-200 bg-sky-50 text-sky-900',
}
const IKON: Record<string, 'check-circle' | 'alert-triangle'> = {
  sukses: 'check-circle',
  galat: 'alert-triangle',
  info: 'check-circle',
}
</script>

<template>
  <div class="pointer-events-none fixed inset-x-0 bottom-0 z-[60] flex flex-col items-center gap-2 p-4 sm:items-end" aria-live="polite" aria-atomic="true">
    <TransitionGroup
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-2 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-for="t in toast.items" :key="t.id"
        class="pointer-events-auto flex w-full max-w-sm items-start gap-2.5 rounded-xl border px-4 py-3 text-sm shadow-soft"
        :class="KELAS[t.jenis]"
      >
        <AppIcon :name="IKON[t.jenis]" class="mt-0.5 h-4 w-4 shrink-0" />
        <span class="min-w-0 flex-1 font-medium">{{ t.pesan }}</span>
        <button type="button" class="shrink-0 rounded p-0.5 opacity-60 hover:opacity-100" aria-label="Tutup" @click="toast.tutup(t.id)">
          <AppIcon name="close" class="h-4 w-4" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>
